import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { domainUrl } from "../../../helper";
import { ArrowRoundedDown12x7Svg, ArrowRoundedUp13x8Svg, File, ImageIcon, No, Yes } from "../../../svg";
import { setDetailUrl, setPopup, setPopupName } from "../../../store/general";
import cls from "../../shared/products/product.module.scss";
import { TranslationsType } from "../../../types/homePageTypes";

interface ICustomDetails {
    detail: {
        attribute_name: string;
        attribute_value: string;
        text_value: string;
        boolean_value: string | null;
        attribute: Array<{ type: string, code: string }>
    };
    showDetailsInFront: boolean;
    dbName: string;
    domain: string;
    translationsData: TranslationsType;
}

const CustomDetailItem: FC<ICustomDetails> = (
    {
        detail,
        domain,
        dbName,
        showDetailsInFront,
        translationsData
    }
) => {
    const {
        attribute_name: attrName,
        attribute_value: attrValue,
        text_value: textValue,
        boolean_value: booleanVal,
        attribute: [{ type: attrType = "", code: attrCode = "" } = {}] = []
    } = detail;

    const [isReadMoreVisible, setIsReadMoreVisible] = useState<boolean>(false);
    const [valClass = "", setValClass] = useState<string>("") || [""];
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const dispatch = useDispatch();
    const valueRef = useRef<HTMLDivElement>(null);

    const handleOpenFile = (url: string) => {
        dispatch(setPopup(true));
        dispatch(setPopupName("details_image"));
        dispatch(setDetailUrl(url));
    };

    useEffect(() => {
        const lineHeight = parseFloat(window.getComputedStyle(valueRef.current!).lineHeight);
        const maxLines = 2;
        const maxHeight = lineHeight * maxLines;

        if (valueRef.current!.clientHeight > maxHeight) {
            setIsReadMoreVisible(true);
            setValClass("detail_content")
        }
    }, [valueRef.current]);

    const attrTypeHandle = (textValue: string, attrName: string, attrType: string, attrValue: string) => {
        const imageElement = (
            <span
                className={cls["icon_for_open"]}
                onClick={() => handleOpenFile(domainUrl(`${dbName}/storage/${domain}/${textValue}`))}
            >
                <ImageIcon />
            </span>
        );
        const fileElement = (
            <span className={cls["icon_for_open"]}>
                <a href={domainUrl(`${dbName}/storage/${domain}/${textValue}`)} download={attrName}>
                    <File />
                </a>
            </span>
        );
        return {
            [attrType]: { "true": attrValue, "false": attrValue },
            boolean: {
                "true": <Yes />,
                "false": <No />
            },
            image: {
                "true": imageElement,
                "false": imageElement
            },
            file: {
                "true": fileElement,
                "false": fileElement
            },
        }
    };

    return (
        <div
            style={{ display: attrCode !== "delivery_days" && showDetailsInFront && !!attrName && (attrType !== "boolean" && !!attrValue || attrType === "boolean") ? 'flex' : 'none' }}
            className={cls["detail_row"]}
        >
            <div className={cls["detail_key"]}>{attrName}</div>
            <div className={cls["detail_value"]}>
                <div
                    className={cls[valClass]}
                    style={{ wordWrap: "break-word" }}
                    ref={valueRef}
                >
                    {attrTypeHandle(textValue, attrName, attrType, attrValue)[attrType][`${!!booleanVal}`]}
                </div>
                {isReadMoreVisible && (
                    <span
                        className={cls["read_more"]}
                        onClick={() => {
                            if (!isOpen) {
                                setValClass("")
                            } else {
                                setValClass("detail_content")
                            }
                            setIsOpen(prevState => !prevState)
                        }}
                    >
                        {isOpen ? (
                            <Fragment>
                                {translationsData?.ReadLess}
                                <ArrowRoundedUp13x8Svg />
                            </Fragment>
                        ) : (
                            <Fragment>
                                {translationsData?.ReadMore}
                                <ArrowRoundedDown12x7Svg />
                            </Fragment>
                        )}
                    </span>
                )}
            </div>
        </div>
    );
};

export default CustomDetailItem;